import React, { useState, useEffect } from 'react'
import { Navbar, Nav, Dropdown, Container, Image } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { useLocation } from 'react-router'
import RRSS from './RRSS'

// Estilos
import '../styles/navigation.styles.scss'

//Imágenes
import logo from '../assets/img/logos/logo_new.png'

const associationRoutes = ['/conocenos', '/cultura-menstrual']

const Navigation = () => {
    const location = useLocation()
    const [background, setBackground] = useState('')
    const [showAssociation, setShowAssociation] = useState(false)
    const [mobileMenuOpen, setMobileMenuOpen] = useState(null)
    const associationActive = location.pathname === '/asociacion' || associationRoutes.includes(location.pathname)
    const whatWeDoActive = location.pathname === '/que-hacemos'

    const toggleMobileMenu = (menu) => {
        setMobileMenuOpen((current) => (current === menu ? null : menu))
    }

    useEffect(() => {
        if(location.pathname === '/' || location.pathname  === '/asociacion') {
            setBackground('')
        } else if (['/encume', '/que-hacemos', '/formacion-ub', ...associationRoutes].includes(location.pathname)) {
            setBackground('dark')
        }
    }, [location])

    return (
        
        <Navbar collapseOnSelect fixed="top" expand="md" bg={background} variant="dark" className='p-0'>
            <Container fluid className='py-3 px-2 px-md-4'>
                <LinkContainer to='/asociacion' activeClassName='no-class'>
                    <Navbar.Brand href="#home" className="text-white py-0">
                        <Image 
                            className='logo'
                            alt='founder-1'
                            src={logo}
                            width='100%'
                        />   
                    </Navbar.Brand>                
                </LinkContainer>

                <Navbar.Toggle aria-controls="responsive-navbar-nav" className='border-0 p-0'/>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="text-right mr-0 ml-md-auto" activeKey={location.pathname} defaultActiveKey='/'>
                            <Dropdown as={Nav.Item} className="section-dropdown" show={showAssociation} onToggle={(show) => setShowAssociation(show)} onMouseEnter={() => setShowAssociation(true)} onMouseLeave={() => setShowAssociation(false)}>
                                <div className="section-dropdown__controls">
                                    <LinkContainer to='/asociacion'>
                                        <Nav.Link className={`section-dropdown__link ${associationActive ? 'active' : ''}`}>
                                            Asociación
                                        </Nav.Link>
                                    </LinkContainer>
                                    <button
                                        type="button"
                                        id="association-nav-dropdown"
                                        className="section-dropdown__toggle"
                                        aria-label="Abrir menú de Asociación"
                                        aria-expanded={mobileMenuOpen === 'association'}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                            toggleMobileMenu('association');
                                        }}
                                    >
                                        <span className="section-dropdown__chevron" aria-hidden="true" />
                                    </button>
                                </div>
                                {mobileMenuOpen === 'association' && (
                                    <div className="section-dropdown__mobile-menu">
                                        <LinkContainer to='/cultura-menstrual'>
                                            <Nav.Link className="section-dropdown__mobile-item">Cultura Menstrual</Nav.Link>
                                        </LinkContainer>
                                        <LinkContainer to='/conocenos'>
                                            <Nav.Link className="section-dropdown__mobile-item">Conócenos</Nav.Link>
                                        </LinkContainer>
                                    </div>
                                )}
                                <Dropdown.Menu alignRight className={showAssociation ? 'show' : ''}>
                                <LinkContainer to='/cultura-menstrual'>
                                    <Dropdown.Item>Cultura Menstrual</Dropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/conocenos'>
                                    <Dropdown.Item>Conócenos</Dropdown.Item>
                                </LinkContainer>
                                </Dropdown.Menu>
                            </Dropdown>
                            <LinkContainer to='/que-hacemos'>
                                <Nav.Link className={`text-white mt-3 mt-md-0 py-0 ${whatWeDoActive ? 'active' : ''}`}>
                                    Qué hacemos
                                </Nav.Link>
                            </LinkContainer>
                            <LinkContainer to='/memorias'>
                                <Nav.Link className="text-white mt-3 mt-md-0 py-0">Memorias</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to='/publicaciones'>
                                <Nav.Link className="text-white mt-3 mt-md-0 py-0">Publicaciones</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to='/formacion-ub'>
                                <Nav.Link className="text-white mt-3 mt-md-0 py-0">Formación UB</Nav.Link>
                            </LinkContainer>
                            <LinkContainer to='/hazte-amiga'>
                                <Nav.Link className="text-white mt-3 mt-md-0 py-0">Hazte amiga</Nav.Link>
                            </LinkContainer>
                            <RRSS align='d-flex justify-content-end text-white ml-2 mt-3 mt-md-0 m-0' size='16' />
                        </Nav>
                </Navbar.Collapse>

            </Container>
        </Navbar>
    )
}

export default Navigation
